'use client';
/** @jsxImportSource @emotion/react */

import type { ButtonGroupProps as MuiButtonGroupProps } from '@mui/material/ButtonGroup';

import MuiButtonGroup from '@mui/material/ButtonGroup';

type ExcludedMuiProps =
  | 'color'
  | 'disableElevation'
  | 'disableFocusRipple'
  | 'disableRipple';

interface ButtonGroupProps extends Omit<MuiButtonGroupProps, ExcludedMuiProps> {
  color?: Exclude<MuiButtonGroupProps['color'], 'inherit'>;
}

export type { ButtonGroupProps };

export const ButtonGroup: React.FC<ButtonGroupProps> = MuiButtonGroup;

ButtonGroup.displayName = 'ButtonGroup';
